// export let DOMAIN = 'carte-des-chantiers-reseau-rhone-alpes-auvergne.fr';
export let DOMAIN = 'chantiers-sncf-auvergnerhonealpes.fr';
// export let DOMAIN = 'sncf.local.dev';
